export const isReloginDialogOpen = state => state?.reloginDialog?.isOpen;
